const listText = {
  text_1: {
    id: "t1",
    mainText: "Apertura de cuenta",
  },
  text_2: {
    id: "t2",
    mainText: "¡Felicidades!",
  },
  text_3: {
    id: "t3",
    mainText:
      "Tu cuenta y servicio de banca se registraron de forma exitosa. El contrato ha sido enviado a tu correo.",
  },
  text_4: {
    id: "t4",
    mainText:
      'Para conocer tus atributos digitales y empezar hacer transferencias vía SPEI es necesario crear tu  contraseña en Consubanco  "Tu Aplicación Móvil".',
  },
  text_5: {
    id: "t5",
    mainText: "Crear mi contraseña",
  },
};

export default listText;
